import { render, staticRenderFns } from "./otherBackstage.vue?vue&type=template&id=79ebb3d8"
import script from "./otherBackstage.vue?vue&type=script&lang=js"
export * from "./otherBackstage.vue?vue&type=script&lang=js"
import style0 from "./otherBackstage.vue?vue&type=style&index=0&id=79ebb3d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports